export default __webpack_public_path__ + "static/media/hl_tip.a3dcc9fa.jpeg";